const mapUserId = file => {
  var _file$addedBy, _file$addedBy2;
  const identityId = ((_file$addedBy = file.addedBy) == null ? void 0 : _file$addedBy.identityId) || '';
  const identityType = (_file$addedBy2 = file.addedBy) == null ? void 0 : _file$addedBy2.identityType;
  if (identityType === 'MEMBER') {
    return `member:${identityId}`;
  }
  if (identityType === 'ANONYMOUS_VISITOR') {
    return `anonymous:${identityId}`;
  }
  if (identityType === 'UNKNOWN') {
    return 'unknown';
  }
  return identityId;
};
export const mapBaseFile = (file, _ref) => {
  let {
    source
  } = _ref;
  const {
    url = '',
    siteId = '',
    parentFolderId,
    id = '',
    labels,
    displayName = '',
    operationStatus,
    createdDate,
    sizeInBytes,
    updatedDate,
    mimeType
  } = file;
  return {
    createdAt: createdDate ? createdDate.getTime() : 0,
    fileInfo: null,
    fileSize: sizeInBytes ? Number(sizeInBytes) : 0,
    fileUrl: url,
    folderId: parentFolderId || '',
    hasMoreItemsInThisCategory: false,
    id,
    kind: 'file',
    labels: labels || [],
    mimeType: mimeType || '',
    name: displayName,
    originalUrl: url,
    previewUrl: url,
    readOnly: null,
    siteId,
    siteMediaToken: '',
    // it shouldn't be file property. Keep it just for type compatibility but with empty string
    source,
    sourceUrl: file.sourceUrl || null,
    tags: file.internalTags || [],
    transcodingStatus: operationStatus,
    thumbnailUrl: file.thumbnailUrl || '',
    updatedAt: updatedDate ? updatedDate.getTime() : 0,
    userId: mapUserId(file)
  };
};
//# sourceMappingURL=BaseFile.mappers.js.map